import React from 'react';
import { Car, Palette, Wine, Gem, ShoppingBag, Watch } from 'lucide-react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip as ReTooltip } from 'recharts';

export const iconMap = {
  car: Car, art: Palette, wine: Wine, jewelry: Gem, handbag: ShoppingBag, watch: Watch,
};

export const categories = [
  { value: '', label: 'All' },
  { value: 'car', label: 'Cars' },
  { value: 'art', label: 'Art' },
  { value: 'watch', label: 'Watches' },
  { value: 'jewelry', label: 'Jewellery' },
  { value: 'wine', label: 'Wine' },
  { value: 'handbag', label: 'Handbags' },
];

// Coming soon pipeline (seeded - not yet in DB)
export const pipeline = [
  { name: 'McLaren F1 LM', category: 'car', status: 'Verification', eta: '48h' },
  { name: 'AP Royal Oak Perpetual', category: 'watch', status: 'Awaiting Custody', eta: '5 days' },
  { name: 'Damien Hirst "For The Love Of God"', category: 'art', status: 'Appraisal', eta: '1 week' },
];

export const timeAgo = (iso) => {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

export const HoldingSparkline = ({ data, positive }) => {
  const chartData = (data || []).map(d => ({
    date: d.date ? new Date(d.date).toLocaleDateString() : '',
    market: d.market_value,
    cost: d.cost_basis,
  }));
  if (chartData.length < 2) {
    return <p className="text-[10px] text-muted-foreground italic">One purchase so far — history will unlock after additional purchases.</p>;
  }
  const color = positive ? '#34d399' : '#f87171';
  return (
    <div className="h-24 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
          <XAxis dataKey="date" tick={{ fontSize: 10, fill: '#666' }} hide />
          <YAxis hide domain={['auto', 'auto']} />
          <ReTooltip
            contentStyle={{ background: '#0A0A0A', border: '1px solid #262626', fontSize: 11 }}
            labelStyle={{ color: '#d4af37' }}
            itemStyle={{ color: '#fff' }}
          />
          <Line type="monotone" dataKey="cost" stroke="#627EEA" strokeDasharray="3 3" dot={false} strokeWidth={1.5} name="Cost basis" />
          <Line type="monotone" dataKey="market" stroke={color} dot={false} strokeWidth={2} name="Market value" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
